<template>
  <VCard class="my-3">
    <VDataTable
      :headers="headers"
      :items="statements"
      :loading="isLoading"
      :pagination.sync="pagination"
      :rows-per-page-items="[15]"
      :total-items="paginationTotal"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td :key="props.index">
          {{ props.item.month | toProperDate }}
        </td>
        <td>{{ props.item.contracts_number }}</td>
        <td>{{ props.item.commission_sum / 100 | toEuro }}</td>

        <td class="text-xs-right">
          <VBtn
            icon
            @click="downloadStatement(props.item.month)"
          >
            <VIcon>cloud_download</VIcon>
          </VBtn>
        </td>
      </template>
    </VDataTable>
  </VCard>
</template>

<script>
import { toEuro, toProperDate } from '@/utils/customFormatters'
import AdminApi from '@/api/AdminApi'
import AgencyManagerApi from '@/api/AgencyManagerApi'
import PaginationApi from '@/api/PaginationApi'
import { ability } from '@/permissions/rules'
import { mapGetters } from 'vuex'

export default {
  name: 'AgencyOverviewStatements',
  filters: {
    toEuro,
    toProperDate
  },
  data () {
    return {
      isLoading: false,
      statements: [],
      pagination: {},
      paginationTotal: 0,
      headers: [
        { text: this.$nt('date'), value: 'date_name', sortable: false },
        { text: this.$nt('contractsNumber'), value: 'contracts_number_name', sortable: false },
        { text: this.$nt('commissionSum'), value: 'commission_sum_name', sortable: false },
        { text: '', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters('agency', ['currentAgency']),
    url () { return this.isAdministrator() ? `agencies/${this.currentAgency.id}/statements` : 'agency/statements' }
  },
  methods: {
    isAdministrator () {
      if (ability.can('read', 'AllAgencies')) {
        return true
      } else {
        return false
      }
    },
    async getPaginatedData () {
      this.isLoading = true
      try {
        const response = await PaginationApi.getPaginatedData(this.url, undefined, this.pagination.page)
        this.paginationTotal = response.total
        this.statements = response.data
      } catch (e) {
        this.$notification(e)
      }
      this.isLoading = false
    },
    async downloadStatement (month) {
      try {
        if (this.isAdministrator()) {
          await AdminApi.downloadStatement(this.currentAgency.id, month)
        } else {
          await AgencyManagerApi.downloadStatement(month)
        }
      } catch (e) {
        this.$notification({
          errors: {
            message: [this.$nt('errorWhileDownloading')]
          }
        })
      }
    }
  },
  watch: {
    pagination: {
      handler: 'getPaginatedData'
    }
  }
}
</script>
